<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,5C12.45,5,12,5.45,12,6C12,6,12,10.59,12,10.59C12,10.59,3.71,2.29,3.71,2.29C3.5300000000000002,2.11,3.2800000000000002,2,3,2C2.45,2,2,2.45,2,3C2,3.2800000000000002,2.11,3.5300000000000002,2.29,3.71C2.29,3.71,10.59,12,10.59,12C10.59,12,6,12,6,12C5.45,12,5,12.45,5,13C5,13.55,5.45,14,6,14C6,14,13,14,13,14C13.55,14,14,13.55,14,13C14,13,14,6,14,6C14,5.45,13.55,5,13,5C13,5,13,5,13,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowBottomRight',
} as DefineComponent
</script>
